/**
 * Sets the highlighted link based on which one was clicked last
 * not as complicated as Courses page
 * @param {JQuery} $target - navigation container
 */
export function navigation($target) {
  const $links = $target.find('a');

  $links.on('click', () => {
    $links.toggleClass('active');
  });
}
